angular.module('impactx.controlstructure').controller('BasketControlStructureCtrl', [
    BasketControlStructureController
]);

function BasketControlStructureController() {
    var self = this;
    self.showAll = false;

    self.$onInit = function () {
        self.showAll = self.initShowAll || false;
    };

    self.toggleAllControlStructures = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        self.showAll = !self.showAll;
    };

    self.showControl = function (controlStructure) {
        return impactX.isDefined(controlStructure, 'identifier') &&
            (self.showAll ||
                self.checkRequire({type: controlStructure.identifier.toLowerCase()}) ||
                controlStructure.set.length > 0)
    }
}